exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mr_10[data-v-01bfd2f2] {\n  margin-right: 0.052083rem;\n}\n.mr_25[data-v-01bfd2f2] {\n  margin-left: 0.130208rem;\n}\n.desc[data-v-01bfd2f2] {\n  color: #636363;\n  font-weight: 400;\n}\n[data-v-01bfd2f2] .label-hidden .el-radio__label {\n  display: none;\n}", ""]);

// exports
